import script from "./DownloadUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadUpdate.vue?vue&type=script&setup=true&lang=js"

import "./DownloadUpdate.vue?vue&type=style&index=0&id=b450b998&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b450b998"]])

export default __exports__